module.exports = __webpack_public_path__ + "static/media/lecture.5ffbab5b.jpg";